module.exports = __webpack_public_path__ + "static/media/delhi-covid-infographics.5fd32ad6.png";